module.exports = __webpack_public_path__ + "static/fosters-mobile-d7a60a8e1b3ef9c0d40c6903ff6739bc.jpg";